import React, { useContext } from 'react'
import { Translations } from '../../services/TranslationService.jsx'
import {
    PDP_SPECIFICATIONS_ID,
    PDP_DETAILS_ID,
    PDP_RESOURCES_ID,
    PDP_REVIEWS_ID,
    PDP_SIMILAR_PRODUCTS_ID,
    PDP_SUPPORT_ID,
    PDP_RELATED_PRODUCTS_ID
} from '../../constants/constants.js'
import {
    useIsDesktop,
    capitalizeEachFirstLetter
} from '../../services/UtilityService.jsx'
import { StateContext } from '../../services/StateService.jsx'
import { getSpecificationsLabel } from '../../services/PDPService.jsx'
import JumpMenu from './JumpMenu.jsx'

/**
 * All ignoring of lines is due to the need of more testing on the
 * functionality of active buttons. This can only be completed by
 * using the Cypress testing library. We determined it's not worth the
 * effort to add a whole new testing library for one small part of
 * a component.
 */
const StickyNavigation = () => {
    const isDesktop = useIsDesktop()
    const translations = useContext(Translations)
    const { productDetails, displayController, locale } = useContext(StateContext)

    const specificationsLabel = getSpecificationsLabel(
        locale,
        productDetails?.divisionCode,
        translations?.specifications,
        translations?.specificationsAlternate
    )

    const createSection = (id, translationKey, condition) => ({
        id,
        label: capitalizeEachFirstLetter(translationKey, locale),
        shouldShow: condition
    })

    const navigationSections = [
        createSection(
            PDP_DETAILS_ID,
            translations?.details,
            displayController?.showDetails
        ),
        createSection(
            PDP_SPECIFICATIONS_ID,
            specificationsLabel,
            displayController?.classificationAttributes
        ),
        createSection(
            PDP_RESOURCES_ID,
            translations?.resources,
            displayController?.showResources
        ),
        createSection(
            PDP_REVIEWS_ID,
            translations?.reviews,
            displayController?.showReviews
        ),
        createSection(
            PDP_SUPPORT_ID,
            translations?.support,
            displayController?.showSupport
        ),
        createSection(
            PDP_SIMILAR_PRODUCTS_ID,
            translations?.similarProducts,
            displayController?.similarProducts
        ),
        createSection(
            PDP_RELATED_PRODUCTS_ID,
            translations?.relatedProductsTemp,
            displayController?.relatedProducts
        )
    ]
        .filter((section) => section.shouldShow)
        .map(({ id, label }) => ({ id, label }))

    return isDesktop ? <JumpMenu sections={navigationSections} /> : null
}

export default StickyNavigation
